import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SwPush } from '@angular/service-worker';
import { environment } from '@env/insitestore360';
import { AppUpdateService } from '@insite-store360/services';
import { CspService } from './services/csp.service';
import { LogPageVisitService } from './services/log-page-visit.service';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'app-root',
  template: ` <router-outlet></router-outlet> `,
  styles: [],
  providers: [SwPush],
})
export class AppComponent implements OnInit {
  message: any = null;
  currentToken: string | null = null;
  title = 'insitestore360';
  apiUrl = environment.apiUrl;
  featureFlag = environment.featureFlag;

  constructor(
    private cspService: CspService,
    _logPageVisitService: LogPageVisitService,
    _appUpdate: AppUpdateService,
  ) {}

  ngOnInit(): void {
    this.cspService.applyCspPolicy();
  }
}
